import React, { useState, useEffect, useCallback } from "react";
import Sidebar from "./Sidebar";
import TopMenu from "./TopMenu";
import BreadcrumbNav from "./BreadcrumbNav";
import CommandPalette from "./CommandPalette";
import { Outlet } from "react-router-dom";
import { useLanguage, t } from "../useTranslations";

const Layout = ({ isSidebarExpanded, toggleSidebar, onLogout }) => {
  // Subscribe to language changes so the entire layout tree re-renders
  useLanguage();
  const [isPaletteOpen, setIsPaletteOpen] = useState(false);

  const openPalette = useCallback(() => setIsPaletteOpen(true), []);
  const closePalette = useCallback(() => setIsPaletteOpen(false), []);

  // Global Ctrl+K listener
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'k' && (e.ctrlKey || e.metaKey)) {
        e.preventDefault();
        setIsPaletteOpen((prev) => !prev);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <div className="app-layout">
      <a href="#main-content" className="skip-to-main">
        {t('app.skipToMain')}
      </a>
      <TopMenu
        onLogout={onLogout}
        onToggleSidebar={toggleSidebar}
        isSidebarExpanded={isSidebarExpanded}
        onOpenCommandPalette={openPalette}
      />
      <div className="main-layout">
        {isSidebarExpanded && <div className="sidebar-backdrop" onClick={toggleSidebar} />}
        <Sidebar isExpanded={isSidebarExpanded} toggleSidebar={toggleSidebar} />
        <div className="content-wrapper">
          <BreadcrumbNav />
          <div id="main-content" className="module-content">
            <Outlet />
          </div>
        </div>
      </div>
      <CommandPalette isOpen={isPaletteOpen} onClose={closePalette} />
    </div>
  );
};

export default Layout;
